import { Fragment } from 'react'
import CitationMarker from '@/components/Citations/CitationMarker'
import { segmentCitationText } from '@/components/Citations/citationTextSegmenter'
import { renderTokens } from './renderTokens'
import { tokenizeInline } from './inlineTokens'

/**
 * The single inline formatter (Stage 2.2, F3). `renderInline` and
 * `FormattedAgentText` are now thin wrappers over this, so a call site can be
 * reverted independently without forking the implementation again.
 *
 * Citations are segmented *first*, then each text segment is tokenized —
 * markers are structural, and tokenizing first would let a `[1]` be swallowed
 * by an adjacent link pattern.
 *
 * @param {string} text
 * @param {Array<{ marker: number }>} citations
 * @param {string} keyBase
 */
export function renderInlineFormat(text, citations = [], keyBase = 'inline') {
  const segments = segmentCitationText(text, citations)
  if (segments.length === 0) return renderTokens(text, keyBase)

  return segments.map((segment, index) => {
    if (segment.type === 'marker') {
      return (
        <CitationMarker
          key={`${keyBase}-marker-${index}`}
          marker={segment.marker}
          citation={segment.citation}
        />
      )
    }
    return (
      <Fragment key={`${keyBase}-text-${index}`}>
        {renderTokens(segment.value, `${keyBase}-text-${index}`)}
      </Fragment>
    )
  })
}

export { tokenizeInline }
